export function emptyToUndefine(value: string) {
  return value.trim() !== '' ? value : undefined;
}
